
var configuration = window.configuration;

if (!configuration)
{
    configuration = {};
}

configuration = {
    'token'              : '',
    'baseUrl'            : 'http://localhost:81/',
    'devMode'            : true,
    'mailManagerSender'  : 'softwareforbusiness@bticino.com',
    'mailManagerSmtp'    : 'localhost'
};
define("configurations/conf", function(){});
